import React from 'react';
import FormInstance  from './form-instance';

export const FormInstanceContext = React.createContext<FormInstance>(new FormInstance());
